import React from "react";
import PropTypes from "prop-types";
import { Select, Type } from "discover.medical.react-component-library";
import {
  StyledFilter,
  StyledSortSelect,
  StyledFiltersWrapper,
  StyledSortWrapper,
} from "./_.styled";

const EMPTY_VALUE = "";
const FILTER_SELECT_NAME = "filter";
const SORT_SELECT_NAME = "sort";

const FilterControls = ({
  filterPlaceholder,
  selectedFilterOption,
  filterOptions,
  onFilterChange,
  sortLabel,
  sortOptions,
  selectedSortOption,
  onSortOptionChange,
  className,
}) => {
  const handleFilterChange = (e) => onFilterChange(e.target.value);
  const handleSortOptionChange = (e) => onSortOptionChange(e.target.value);

  return (
    <StyledFiltersWrapper className={className}>
      <StyledFilter
        name={FILTER_SELECT_NAME}
        value={selectedFilterOption}
        onChange={handleFilterChange}
        aria-label={FILTER_SELECT_NAME}
      >
        <Select.Option value={EMPTY_VALUE}>{filterPlaceholder}</Select.Option>
        {filterOptions.map((option) => (
          <Select.Option key={option} value={option}>
            {option}
          </Select.Option>
        ))}
      </StyledFilter>
      <StyledSortWrapper>
        <Type>{sortLabel}</Type>
        <StyledSortSelect
          name={SORT_SELECT_NAME}
          value={selectedSortOption}
          onChange={handleSortOptionChange}
          aria-label={SORT_SELECT_NAME}
        >
          {sortOptions.map((option) => (
            <Select.Option key={option.value} value={option.value}>
              {option.label}
            </Select.Option>
          ))}
        </StyledSortSelect>
      </StyledSortWrapper>
    </StyledFiltersWrapper>
  );
};

const sortOptionPropType = PropTypes.shape({
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
});

FilterControls.propTypes = {
  filterPlaceholder: PropTypes.string.isRequired,
  selectedFilterOption: PropTypes.string.isRequired,
  filterOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
  onFilterChange: PropTypes.func.isRequired,
  sortLabel: PropTypes.string.isRequired,
  sortOptions: PropTypes.arrayOf(sortOptionPropType).isRequired,
  selectedSortOption: PropTypes.string.isRequired,
  onSortOptionChange: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default FilterControls;
